import { http } from '@/lib/ats-https';

const addEmailAttachmentsToFiles = async (params) => {
  const response = await http.post(
    `/ats_applications/${params?.application_id}/candidate_messages/${params?.candidate_message_id}/add_attachment_to_files`,
    { attachment_id: params?.attachment_id }
  );
  return response;
};

export const ATTACHMENT_API_SERVICE = {
  addEmailAttachmentsToFiles,
};
